export enum UserRoles {
  adminEditor = "ADMIN_EDITOR",
  restaurantAdmin = "RESTAURANT_ADMIN",
  deliveryManage = "DELIVERY_MANAGE",
  guestAnalytics = "GUEST_ANALYTICS",
  crmProfileView = "CRM_PROFILE_VIEW",
  aidaAnalytics = "AIDA_ANALYTICS",
}
